export function $notifyError($this, error, errorMessageOverride) {
	const errorMsg = error.response?.data?.error?.message;
	if (!error || (error && !error?.toString().includes("with status code 401"))) {
		$this.$notify({
			title: "Error",
			message: errorMessageOverride || errorMsg || "An error occurred, " + error,
			type: "error",
			position: "bottom-left",
		});
	}
}
